module.exports = __webpack_public_path__ + "img/item11.5894d67e.png";